import { MOTION } from "@elyxeer/ui";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link as RouterLink } from "react-router-dom";

import { openExternal } from "~/lib/external-link";

import type { SettingsAction, SettingsItem } from "./settings-nav";

export function SettingsRow({
  item,
  label,
  first,
  onAction,
  externalUrl,
}: {
  item: SettingsItem;
  label: string;
  first: boolean;
  onAction?: (action: SettingsAction) => void;
  externalUrl?: string;
}) {
  const Icon = item.icon;
  const contentColor = item.kind === "action" ? "error.main" : "text.muted";
  const content = (
    <>
      <ListItemIcon sx={{ minWidth: 40, color: contentColor }}>
        <Icon fontSize="small" />
      </ListItemIcon>

      <ListItemText
        primary={label}
        slotProps={{
          primary: {
            variant: "L1",
            sx: {
              color: item.kind === "action" ? "error.main" : "text.primary",
            },
          },
        }}
      />

      {item.kind === "external" ? (
        <OpenInNewIcon
          sx={{
            color: "text.muted",
            flexShrink: 0,
            fontSize: 24,
            width: 24,
            height: 24,
            marginLeft: "auto",
          }}
        />
      ) : (
        <ChevronRightIcon
          sx={{
            color: contentColor,
            flexShrink: 0,
            fontSize: 24,
            width: 24,
            height: 24,
            marginLeft: "auto",
          }}
        />
      )}
    </>
  );
  const sx = {
    paddingBlock: 1.75,
    paddingInline: 2.5,
    width: "100%",
    gap: 1,
    transition: `background-color ${MOTION.transition}`,
    // Hairlines between rows, none above the first.
    borderTop: first ? "none" : "1px solid",
    borderColor: "divider",
  };

  if (item.kind === "action") {
    return (
      <ListItemButton
        component="button"
        type="button"
        onClick={() => onAction?.(item.action)}
        data-testid={`profile.menu-${item.key}`}
        sx={sx}
      >
        {content}
      </ListItemButton>
    );
  }

  if (item.kind === "external") {
    return (
      <ListItemButton
        component="button"
        type="button"
        onClick={() => void openExternal(externalUrl ?? item.url)}
        data-testid={`profile.menu-${item.key}`}
        sx={sx}
      >
        {content}
      </ListItemButton>
    );
  }

  return (
    <ListItemButton
      component={RouterLink}
      to={item.path}
      data-testid={`profile.menu-${item.key}`}
      sx={sx}
    >
      {content}
    </ListItemButton>
  );
}
